const USD_DEFAULT = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 4,
  maximumFractionDigits: 6,
});

const USD_COMPACT = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const INT_FMT = new Intl.NumberFormat("en-US");

export function formatUsd(amount: number | null | undefined): string {
  if (amount == null) return "—";
  return USD_DEFAULT.format(amount);
}

export function formatUsdCompact(amount: number | null | undefined): string {
  if (amount == null) return "—";
  return USD_COMPACT.format(amount);
}

export function formatTokens(tokens: number | null | undefined): string {
  if (tokens == null) return "—";
  return INT_FMT.format(tokens);
}

export function formatInt(value: number | null | undefined): string {
  if (value == null) return "—";
  return INT_FMT.format(value);
}

export function formatDateISO(date: Date | string | null | undefined): string {
  if (!date) return "—";
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toISOString().slice(0, 10);
}

export function formatDateTime(date: Date | string | null | undefined): string {
  if (!date) return "—";
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return "—";
  return d.toISOString().replace("T", " ").slice(0, 19) + "Z";
}

export function formatRelativeTime(
  date: Date | string | null | undefined,
  now: Date = new Date(),
): string {
  if (!date) return "—";
  const d = typeof date === "string" ? new Date(date) : date;
  if (Number.isNaN(d.getTime())) return "—";
  const diffSec = (now.getTime() - d.getTime()) / 1000;
  if (diffSec < 60) return "gerade eben";
  if (diffSec < 3600) return `vor ${Math.floor(diffSec / 60)} min`;
  if (diffSec < 86400) return `vor ${Math.floor(diffSec / 3600)} h`;
  if (diffSec < 30 * 86400) return `vor ${Math.floor(diffSec / 86400)} d`;
  return formatDateISO(d);
}
